import {
  AccountClient,
  AdvisorClient,
  ApplicationProfileClient,
  AuthClient,
  EmailClient,
  ExamRegistrationClient,
  ExcelTemplateClient,
  ImportClient,
  LabelClient,
  ModuleManagementClient,
  ModuleSelectionClient,
  PriorityClient,
  ProfileClient,
  RegistrationClient,
  RegistrationEditClient,
  RegistrationExportClient,
  RegistrationFilterPresetClient,
  registry,
  RoleSelectionClient,
  RuleClient,
  SemesterManagementClient,
  SemesterSelectionClient,
  StudentClient,
  SummarySheetClient,
  UasClient,
  UasDomainClient,
} from '@mse-reg/clients';
import axios, { AxiosInstance } from 'axios';
import setupAxiosInterceptors from './axios-interceptor';
import { AppDispatch } from './store-types';

// Use empty string for relative URLs (goes through webpack proxy in dev)
const API_BASE_URL = '';

export function configureServices(dispatch: AppDispatch): void {
  registry.addSingleton('Axios', () => {
    const instance = axios.create({
      withCredentials: true, // send cookies with cross-origin requests
    });

    setupAxiosInterceptors(instance, dispatch);
    return instance;
  });

  registry.addTransient(
    'IRegistrationClient',
    (resolver) => new RegistrationClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IModuleSelectionClient',
    (resolver) => new ModuleSelectionClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IModuleManagementClient',
    (resolver) => new ModuleManagementClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IPriorityClient',
    (resolver) => new PriorityClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IProfileClient',
    (resolver) => new ProfileClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'ILabelClient',
    (resolver) => new LabelClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IApplicationProfileClient',
    (resolver) => new ApplicationProfileClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IImportClient',
    (resolver) => new ImportClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IAuthClient',
    (resolver) => new AuthClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IAccountClient',
    (resolver) => new AccountClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'ISemesterManagementClient',
    (resolver) => new SemesterManagementClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'ISemesterSelectionClient',
    (resolver) => new SemesterSelectionClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IRegistrationExportClient',
    (resolver) => new RegistrationExportClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IRoleSelectionClient',
    (resolver) => new RoleSelectionClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IStudentClient',
    (resolver) => new StudentClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IAdvisorClient',
    (resolver) => new AdvisorClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IRegistrationEditClient',
    (resolver) => new RegistrationEditClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IEmailClient',
    (resolver) => new EmailClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient('IUasClient', (resolver) => new UasClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')));
  registry.addTransient(
    'IUasDomainClient',
    (resolver) => new UasDomainClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IExcelTemplateClient',
    (resolver) => new ExcelTemplateClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IRegistrationFilterPresetClient',
    (resolver) => new RegistrationFilterPresetClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'ISummarySheetClient',
    (resolver) => new SummarySheetClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IRuleClient',
    (resolver) => new RuleClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
  registry.addTransient(
    'IExamRegistrationClient',
    (resolver) => new ExamRegistrationClient(API_BASE_URL, resolver.resolve<AxiosInstance>('Axios')),
  );
}
